/**
*  Copyright (c) 2021 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { RequestslistService } from '../services/requestslist.service';
import { RequestsListResponse, RequestBasicInfoResultEntity } from '../model/requestslistresponse';
import { CustomerPreferenceService } from '../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../preference/customerpreference.model';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { RequestlistSearchService } from '../services/requestlist-searchservice';
import { RequestDetailService } from '../services/request-detail.service';
import { RequestDetailResponse } from '../model/requestdetailresponse';
import { RequestActions } from '../model/requestsactionsresponse';
import { Actions } from '../model/requestupdateinfo';
import { RequestInfo } from '../model/requestinforesponse';
import { RequestAttachment } from '../model/requestattachmentresponse';
import * as FileSaver from 'file-saver';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType, HttpParams } from '@angular/common/http';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { Subscription } from 'rxjs/Subscription';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { BannerComponent } from '../../../view/banner/banner.component';
import { RequestsService } from '../services/requests.service';
import { RequestsFilterInfo } from '../model/requestsfilterinfo';
import { ZSDTranslateService } from './../../../../common/zsd-translate.service';

declare var $: any;
declare var moment: any;
@Component({
  selector: 'zsd-requestslist',
  templateUrl: '../view/requestslist.component.html',
  styleUrls: ['../view/requestslist.component.scss']
})
export class RequestsListComponent implements OnInit, OnDestroy {
  requestPerPage = 20;
  page = 0;
  sortBy = 'lastActionDate';
  sortOrder = 'DESC';
  maxNoOfRequests;
  isRequestList;
  scrollEndReached = false;
  showSubject;
  showTechnician;
  isLoading = false;
  attachmentIsLoading = false;
  reqNumber: number;
  itemClicked: Array<any> = [];
  requestDetails: any = {};
  setSelectedRow: number;
  selectedRow: number;
  showDetails: boolean;
  noRecords: string;
  actions: Actions[];
  clickedAction: boolean;
  spinnerStart = true; // adding for showing spinner while loading instead of No request message
  attachmentSpinnerStart = true;
  searchRequestListSubscription: Subscription;
  selectedActionSubscription: Subscription;
  showExpanded: boolean;
  isDesc = true;
  column;
  direction;
  requestBasicInfoResponse = new Array<RequestBasicInfoResultEntity>();
  requestListResponse: RequestsListResponse = new RequestsListResponse();
  requestDetailResponse: RequestDetailResponse = new RequestDetailResponse();
  reqAttachmentResponse = new Array<RequestAttachment>();
  requestsfilterInfo: RequestsFilterInfo = new RequestsFilterInfo();

  requestInEditMode: Set<number>;
  addRequestSubscription: Subscription;
  removeRequestSubscription: Subscription;

  requestNumberForAttachment: number;

  static createdFromDate: string;
  static createdToDate: string;
  static sun: string;
  static mon: string;
  static tue: string;
  static wed: string;
  static thu: string;
  static fri: string;
  static sat: string;
  static jan: string;
  static feb: string;
  static mar: string;
  static apr: string;
  static may: string;
  static jun: string;
  static jul: string;
  static aug: string;
  static sep: string;
  static oct: string;
  static nov: string;
  static dec: string;

  constructor(public requestListsService: RequestslistService, public spinnerService: SpinnerService,
    public customerPreferenceService: CustomerPreferenceService, public requestlistSearchService: RequestlistSearchService,
    public requestDetailService: RequestDetailService, public requestListSearchService: RequestlistSearchService,
    public http: HttpClient, private route: ActivatedRoute, public requestsService: RequestsService,
    private zsdTranslate: ZSDTranslateService) {
    this.requestInEditMode = new Set();
    this.subscribeToAddRequestToEditList();
    this.subscribeToRemoveRequestFromEditList();
    this.getPreferencesList();
    this.requestBasicInfoResponse = new Array<RequestBasicInfoResultEntity>();
    this.subscribeSelectedAction();
    if (this.zsdTranslate.getTranslateService().store.translations[this.zsdTranslate.getTranslateService().currentLang]) {
      // check if translated json file already available
      this.initializeDateTimePicker();
    } else {
      this.zsdTranslate.getTranslateService().onDefaultLangChange.pipe(take(1)).subscribe(_ => this.initializeDateTimePicker());
      // wait for new translated json file to get loaded by subscribing to it
    }
  }


  ngOnInit() {
    /*     $(document).ready(() => {
          this.initializeDateTimePicker();
        }); */
    /* To refresh Global search dropdown */
    BannerComponent.refreshGlobalSearchDropdown.next(false);
    this.sort('lastActionDate');
    $(document).ready(() => {
      $('#reportrangeRequests').on('apply.daterangepicker', () => {
        this.requestsfilterInfo.createdFromDate = RequestsListComponent.createdFromDate;
        this.requestsfilterInfo.createdToDate = RequestsListComponent.createdToDate;
        this.isLoading = false;
        this.page = 0;
        this.requestBasicInfoResponse = [];
        this.getRequestsList(this.page, this.sortBy, this.sortOrder, this.requestsfilterInfo);
      });
    });
  }

  initFilter() {
    let categoryIds = new Array<number>();
    let itemTypeIds = new Array<number>();
    let statusTypeIds = new Array<number>();
    this.route.queryParams.subscribe(params => {
      if (params['searchTerm']) {

        let searchParam: string = JSON.parse(params['searchTerm']);
        if (searchParam.includes('id:') && !Number.isNaN(Number(searchParam.substring(3)))) {
          this.showExpanded = true;
        }
        this.requestsfilterInfo.searchTerm = JSON.parse(params['searchTerm']);
      }
      if (params['categoryIds']) {
        categoryIds = JSON.parse(params['categoryIds']);
      }
      if (params['itemTypeIds']) {
        itemTypeIds = JSON.parse(params['itemTypeIds']);
      }
      if (params['statusTypeIds']) {
        statusTypeIds = JSON.parse(params['statusTypeIds']);
      }
      if (params['awaitingMyApproval']) {
        this.requestsfilterInfo.awaitingMyApproval = JSON.parse(params['awaitingMyApproval']);
      }
      if (params['awaitingMyInputs']) {
        this.requestsfilterInfo.awaitingMyInputs = JSON.parse(params['awaitingMyInputs']);
      }
      if (params['openRequestsOnly']) {
        this.requestsfilterInfo.openRequestsOnly = JSON.parse(params['openRequestsOnly']);
      } else {
        this.requestsfilterInfo.openRequestsOnly = false;
      }
    });
    this.requestsfilterInfo.categoryIds = categoryIds;
    this.requestsfilterInfo.itemTypeIds = itemTypeIds;
    this.requestsfilterInfo.statusTypeIds = statusTypeIds;
  }

  sort(property) {
    this.initializeRequestParameters();
    $('#property').removeClass('fa fa-sort');
    this.isDesc = !this.isDesc;
    this.column = property;
    if (this.isDesc === true) {
      this.sortOrder = 'ASC';
    } else {
      this.sortOrder = 'DESC';
    }
    this.sortBy = property;
    this.initFilter();
    this.applyFilterParamaeter(this.requestsfilterInfo);
  }
  applyFilterParamaeter(requestsfilterInfo: RequestsFilterInfo) {
    if (requestsfilterInfo) {
      this.getRequestsList(this.page, this.sortBy, this.sortOrder, requestsfilterInfo);
    } else {
      requestsfilterInfo.searchTerm = '';
      requestsfilterInfo.categoryIds = [];
      requestsfilterInfo.itemTypeIds = [];
      requestsfilterInfo.statusTypeIds = [];
      requestsfilterInfo.awaitingMyApproval = null;
      requestsfilterInfo.awaitingMyInputs = null;
      requestsfilterInfo.openRequestsOnly = null;
      requestsfilterInfo.createdFromDate = null;
      requestsfilterInfo.createdToDate = null;
      this.getRequestsList(this.page, this.sortBy, this.sortOrder, requestsfilterInfo);
    }
  }

  getPreferencesList() {
    this.customerPreferenceService.getPreferenceList().
      subscribe((customerPreferenceResponse: CustomerPreferenceResponse) => {
        this.showSubject = customerPreferenceResponse.showSubject;
        this.showTechnician = customerPreferenceResponse.showTechnician;
      });
  }

  initializeRequestParameters() {
    this.isLoading = false;
    this.page = 0;
    this.isRequestList = false;
    this.requestBasicInfoResponse = [];
  }

  getRequestsList(pageNo: number, sortBy: string, sortOrder: string, requestsfilterInfo: RequestsFilterInfo) {
    let params = new HttpParams()
      .set('offset', this.page.toString())
      .set('limit', this.requestPerPage.toString())
      .set('sortBy', this.sortBy)
      .set('sortOrder', this.sortOrder);

    if (requestsfilterInfo.itemTypeIds) {
      for (let i = 0; i < requestsfilterInfo.itemTypeIds.length; i++) {
        params = params.append('itemTypeIds', requestsfilterInfo.itemTypeIds[i].toString());
      }
    }

    if (requestsfilterInfo.categoryIds) {
      for (let i = 0; i < requestsfilterInfo.categoryIds.length; i++) {
        params = params.append('categoryIds', requestsfilterInfo.categoryIds[i].toString());
      }
    }

    if (requestsfilterInfo.statusTypeIds) {
      for (let i = 0; i < requestsfilterInfo.statusTypeIds.length; i++) {
        params = params.append('statusTypeIds', requestsfilterInfo.statusTypeIds[i].toString());
      }
    }

    if (requestsfilterInfo.searchTerm !== null && requestsfilterInfo.searchTerm) {
      params = params.append('searchTerm', requestsfilterInfo.searchTerm);
    }
    if (requestsfilterInfo.awaitingMyApproval !== null && requestsfilterInfo.awaitingMyApproval === true) {
      params = params.append('awaitingMyApproval', requestsfilterInfo.awaitingMyApproval.toString());
    }
    if (requestsfilterInfo.openRequestsOnly !== null && requestsfilterInfo.openRequestsOnly === true) {
      params = params.append('openRequestsOnly', requestsfilterInfo.openRequestsOnly.toString());
    }

    if (requestsfilterInfo.awaitingMyInputs !== null && requestsfilterInfo.awaitingMyInputs === true) {
      params = params.append('needMyInput', requestsfilterInfo.awaitingMyInputs.toString());
    }

    if (requestsfilterInfo.createdFromDate !== null && requestsfilterInfo.createdFromDate) {
      params = params.append('createdFromDate', requestsfilterInfo.createdFromDate);
    }

    if (requestsfilterInfo.createdToDate !== null && requestsfilterInfo.createdToDate) {
      params = params.append('createdToDate', requestsfilterInfo.createdToDate);
    }

    if (!this.isLoading) {
      this.isLoading = true;
      this.spinnerService.show();
      if (pageNo === -1) {
        this.isLoading = true;
        this.spinnerService.show();
        this.page = 0;
        this.sortBy = sortBy;
        this.sortOrder = sortOrder;
        this.initializeRequestParameters();
        pageNo = 0;
      }
      this.requestListsService
        .getRequestsList(params)
        .subscribe(
          (requestsListResponse: RequestsListResponse) => {
            this.maxNoOfRequests = requestsListResponse.resultCount;
            if (this.maxNoOfRequests > 0) {
              this.isRequestList = true;
              this.scrollEndReached = false;
            }
            if (!this.maxNoOfRequests) {
              this.noRecords = 'DataTableList.noRecords';
            }
            this.requestBasicInfoResponse = this.requestBasicInfoResponse.concat(
              requestsListResponse.results
            );
            this.page++;
            if (this.requestBasicInfoResponse.length >= this.maxNoOfRequests) {
              // reached end of list
              this.scrollEndReached = true;
            }
            this.isLoading = false;
            this.spinnerStart = false;
          },
          err => {
            console.error(err.error);
            this.isLoading = false;
            this.spinnerStart = false;
            this.noRecords = 'DataTableList.noRecords';
          }
        );
    }
  }

  getListAttachment(requestNumber: number, $event: any, id: string) {
    this.requestNumberForAttachment = requestNumber;
    this.reqAttachmentResponse = null;
    this.attachmentIsLoading = true;
    this.requestListsService.getAttachmentDetails(requestNumber).subscribe((requestAttachment: any) => {
      this.reqAttachmentResponse = requestAttachment;
      this.attachmentIsLoading = false;
      this.attachmentSpinnerStart = false;
    });

    $event.stopPropagation();
    $(id).modal('show');
  }

  scrollEnd() {
    if (!this.scrollEndReached) {
      this.initFilter();
      this.getRequestsList(this.page, this.sortBy, this.sortOrder, this.requestsfilterInfo);
    }
  }
  scrollCur() {
  }

  /* Fix for Refresh - and Scroll position to Top Issue */

  @HostListener('window:beforeunload', ['$event']) unloadHandler() {
    new RequestsListComponent(this.requestListsService, this.spinnerService,
      this.customerPreferenceService, this.requestlistSearchService,
      this.requestDetailService, this.requestListSearchService, this.http, this.route,
      this.requestsService, this.zsdTranslate);
    window.scrollTo(0, 0);
  }


  sendRequestNumber(index) {
    this.itemClicked.push(index);
    this.selectedRow = index;
  }

  sendOption(currentRequest: RequestBasicInfoResultEntity, action: Actions, elementId: string, $event: any, dropdownId: string) {
    currentRequest.action = action;
    // To set focus on TinyMCE Editor
    if (action !== Actions.NOACTIONS) {
      if (action) {
        this.clickedAction = true;
      }
      this.requestListsService.applyAction(currentRequest);
      if ($(elementId).hasClass('show')) {
        if ($(dropdownId).hasClass('show')) {
          $(dropdownId).dropdown('toggle');
        }
        $event.stopPropagation();
      } else {
        $(elementId).collapse('toggle');
      }
    } else {
      $event.stopPropagation();
    }
  }

  openDropdown(requestNumber) {
    this.actions = [];
    this.requestListsService.getRequestsActions(requestNumber)
      .subscribe((requestActions: RequestActions) => {
        this.actions = new Array<Actions>();
        if (requestActions.addNote) {
          this.actions.push(Actions.ADDNOTE);
        }

        if (requestActions.canApprove) {
          this.actions.push(Actions.APPROVE);
        }

        if (requestActions.canReject) {
          this.actions.push(Actions.REJECT);
        }

        if (requestActions.esclate) {
          this.actions.push(Actions.ESCALATE);
        }

        if (requestActions.deEscalate) {
          this.actions.push(Actions.DEESCALATE);
        }

        if (requestActions.closeResolved) {
          this.actions.push(Actions.CLOSE);
        }

        if (requestActions.reopen) {
          this.actions.push(Actions.REOPEN);
        }
        if (this.actions.length === 0) {
          this.actions.push(Actions.NOACTIONS);
        }
      },
        () => {
          if (this.actions.length === 0) {
            this.actions.push(Actions.NOACTIONS);
          }
        }
      );
  }

  trackByRequests(index) {
    return index;
  }

  subscribeSelectedAction() {
    this.selectedActionSubscription = this.requestListsService.getUpdatedRequestChanges().subscribe((requestInfo: RequestInfo) => {
      this.requestBasicInfoResponse[this.selectedRow].status = requestInfo.status;
      this.requestBasicInfoResponse[this.selectedRow].technician = requestInfo.technician;
      this.requestBasicInfoResponse[this.selectedRow].hasAttachment = requestInfo.hasAttachment;
      this.requestBasicInfoResponse[this.selectedRow].isOnNeedinfo = requestInfo.isOnNeedinfo;
      this.requestBasicInfoResponse[this.selectedRow].isAwaitingMyApproval = requestInfo.isAwaitingMyApproval;
      this.requestBasicInfoResponse[this.selectedRow].updatedOn = requestInfo.updatedOn;
    });
  }

  attachmentDetails(requestAttachment: RequestAttachment) {
    this.attachmentIsLoading = true;
    let attachmentParentType = (requestAttachment.attachmentType === 1) ? 'GroupAttachment' : 'IncidentAttachment';
    this.downloadAttachment(requestAttachment.attachmentId, attachmentParentType, this.requestNumberForAttachment);
  }

  downloadAttachment(attachmentId: number, attachmentParentType: String, parentEntityId: number) {
    const downloadRequest = new HttpRequest('GET', CommonConstants.SERVICE_VERSION_PATH_V1 + '/file/download/' + attachmentId +
      '?attachmentParentType=' + attachmentParentType + '&parentEntityId=' + parentEntityId, {
        responseType: 'blob'
      });

    this.http.request(downloadRequest).subscribe(
      (event: HttpEvent<any>) => {
        if (event) {
          switch (event.type) {
            case HttpEventType.ResponseHeader:
              let contentDispositionHeader = event.headers.get('Content-Disposition');
              contentDispositionHeader = contentDispositionHeader.substr(22, (contentDispositionHeader.length - 1));
              console.log(contentDispositionHeader); // Always null here although I expected it to be there.
              break;

            case HttpEventType.Response:
              let contentDispositionHeader2 = event.headers.get('Content-Disposition');
              contentDispositionHeader2 = contentDispositionHeader2.substr(22, (contentDispositionHeader2.length - 23));
              const downloadedFile: Blob = event.body;
              this.attachmentIsLoading = false;
              FileSaver.saveAs(downloadedFile, contentDispositionHeader2);
              break;
          }
        }
      },
      err => {
        console.log(err.error);
        this.attachmentIsLoading = false;
      }

    );
  }
  subscribeToAddRequestToEditList() {
    this.addRequestSubscription = this.requestsService.getRequestMovedToEditMode().subscribe((requestNumber: number) => {
      this.requestInEditMode.add(requestNumber);
    });
  }

  subscribeToRemoveRequestFromEditList() {
    this.removeRequestSubscription = this.requestsService.getRequestRemovedFromEditMode().subscribe((requestNumber: number) => {
      this.requestInEditMode.delete(requestNumber);
    });
  }

  isAnyRequestInEditMode(): boolean {
    return (this.requestInEditMode != null && this.requestInEditMode.size > 0);
  }

  ngOnDestroy() {
    if (this.searchRequestListSubscription) {
      this.searchRequestListSubscription.unsubscribe();
    }
    if (this.selectedActionSubscription) {
      this.selectedActionSubscription.unsubscribe();
    }
    this.addRequestSubscription.unsubscribe();
    this.removeRequestSubscription.unsubscribe();
  }

  initializeDateTimePicker() {
    let allLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'all');
    let lastWeekLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'lastWeek');
    let lastMonthLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'lastMonth');
    let customLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'custom');
    let applyLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'applyButton');
    let cancelLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'cancelButton');
    RequestsListComponent.sun = this.zsdTranslate.getTranslatedString('CommonStrings', 'sun');
    RequestsListComponent.mon = this.zsdTranslate.getTranslatedString('CommonStrings', 'mon');
    RequestsListComponent.tue = this.zsdTranslate.getTranslatedString('CommonStrings', 'tue');
    RequestsListComponent.wed = this.zsdTranslate.getTranslatedString('CommonStrings', 'wed');
    RequestsListComponent.thu = this.zsdTranslate.getTranslatedString('CommonStrings', 'thu');
    RequestsListComponent.fri = this.zsdTranslate.getTranslatedString('CommonStrings', 'fri');
    RequestsListComponent.sat = this.zsdTranslate.getTranslatedString('CommonStrings', 'sat');
    RequestsListComponent.jan = this.zsdTranslate.getTranslatedString('CommonStrings', 'jan');
    RequestsListComponent.feb = this.zsdTranslate.getTranslatedString('CommonStrings', 'feb');
    RequestsListComponent.mar = this.zsdTranslate.getTranslatedString('CommonStrings', 'mar');
    RequestsListComponent.apr = this.zsdTranslate.getTranslatedString('CommonStrings', 'apr');
    RequestsListComponent.may = this.zsdTranslate.getTranslatedString('CommonStrings', 'may');
    RequestsListComponent.jun = this.zsdTranslate.getTranslatedString('CommonStrings', 'jun');
    RequestsListComponent.jul = this.zsdTranslate.getTranslatedString('CommonStrings', 'jul');
    RequestsListComponent.aug = this.zsdTranslate.getTranslatedString('CommonStrings', 'aug');
    RequestsListComponent.sep = this.zsdTranslate.getTranslatedString('CommonStrings', 'sep');
    RequestsListComponent.oct = this.zsdTranslate.getTranslatedString('CommonStrings', 'oct');
    RequestsListComponent.nov = this.zsdTranslate.getTranslatedString('CommonStrings', 'nov');
    RequestsListComponent.dec = this.zsdTranslate.getTranslatedString('CommonStrings', 'dec');

    $(function () {
      $('#reportrangeRequests span').html(allLabel);
      let start = moment();
      let end = moment();

      $('#reportrangeRequests').daterangepicker({
        startDate: start,
        endDate: end,
        timePicker: false,
        showDropdowns: true,
        opens: 'left',
        timePickerIncrement: false,
        alwaysShowCalendars: false,
        linkedCalendars: false,
        locale: {
          'format': 'MM/DD/YYYY',
          'applyLabel': applyLabel,
          'cancelLabel': cancelLabel,
          'customRangeLabel': customLabel,
          'daysOfWeek': [
            RequestsListComponent.sun,
            RequestsListComponent.mon,
            RequestsListComponent.tue,
            RequestsListComponent.wed,
            RequestsListComponent.thu,
            RequestsListComponent.fri,
            RequestsListComponent.sat
          ],
          'monthNames': [
            RequestsListComponent.jan,
            RequestsListComponent.feb,
            RequestsListComponent.mar,
            RequestsListComponent.apr,
            RequestsListComponent.may,
            RequestsListComponent.jun,
            RequestsListComponent.jul,
            RequestsListComponent.aug,
            RequestsListComponent.sep,
            RequestsListComponent.oct,
            RequestsListComponent.nov,
            RequestsListComponent.dec
          ]
        },
        ranges: {
          [allLabel]: [moment(), moment()],
          [lastWeekLabel]: [moment().subtract(6, 'days'), moment()],
          [lastMonthLabel]: [moment().subtract(29, 'days'), moment()],
        }
      }, function (startDate, endDate, label) {
        if (label === allLabel) {
          $('#reportrangeRequests span').html(allLabel);
          RequestsListComponent.createdFromDate = null;
          RequestsListComponent.createdToDate = null;
        } else if (label === lastWeekLabel) {
          $('#reportrangeRequests span').html(lastWeekLabel);
          RequestsListComponent.createdFromDate = startDate.format('MM/D/YY');
          RequestsListComponent.createdToDate = endDate.format('MM/D/YY');
        } else if (label === lastMonthLabel) {
          $('#reportrangeRequests span').html(lastMonthLabel);
          RequestsListComponent.createdFromDate = startDate.format('MM/D/YY');
          RequestsListComponent.createdToDate = endDate.format('MM/D/YY');
        } else {
          $('#reportrangeRequests span').html(customLabel);
          RequestsListComponent.createdFromDate = startDate.format('MM/D/YY');
          RequestsListComponent.createdToDate = endDate.format('MM/D/YY');
        }
      });
    });
  }
}
